import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GameService } from '../services/game.service';
import { SharedService } from '../services/shared.service';
import { AuthService } from '../services/auth.service';
import { Game } from '../classes/Game';

@Component({
  selector: 'app-add-team',
  templateUrl: './add-team.component.html',
  styleUrls: ['./add-team.component.scss']
})
export class AddTeamComponent implements OnInit {

  @Input() targetGame: Game;
  @Input() prefabTeam: TeamStub;
  @Input() inGameTeams: Team[];
  @Output() choseSpectate: EventEmitter<any> = new EventEmitter<any>();
  @Output() needAuth: EventEmitter<any> = new EventEmitter<any>();
  @Output() teamChosen: EventEmitter<boolean> = new EventEmitter<boolean>();

  chosenTeam: TeamStub;
  memberList: Member[];
  teamList: TeamStub[];
  teamLoading: boolean = true;
  err = "";
  editName: boolean;
  teamLocked: boolean;
  hideWarn = false;
  isLoggedIn: boolean;
  numPlayers: number;
  readyJoin: boolean;
  invites: Invite[] = [];
  selected_team: any;
  loading: boolean;

  constructor(
    private gameService: GameService,
    private sharedService: SharedService,
    private auth: AuthService) { }

  ngOnInit(): void {
    this.isLoggedIn = this.auth.getToken() ? true : false;
    if (this.isLoggedIn) this.getMyTeams();
    else this.processTeamList([]);
    if (this.prefabTeam) this.chosenTeam = { ...this.prefabTeam };
  }

  getMyTeams() {
    this.gameService.getTeams(true)
      .subscribe((teams: TeamStub[]) => {
        this.teamList = this.processTeamList(teams);
      },
        err => {
          let teamDef: any = []
          this.teamList = teamDef;
          this.teamLoading = false;
          this.err = "Error retrieving teams!";
        })
  }

  clearTeam() {
    this.chosenTeam = null;
    this.selected_team = null;
    // console.log(this.chosenTeam);
    // this.teamChosen.emit(false);
    // console.log(this.chosenTeam);
  }

  spectate() {
    this.choseSpectate.emit("");
  }

  toAuth() {
    this.needAuth.emit("");
  }

  processTeamList(myTeams: TeamStub[]) {
    let gameTeams = this.targetGame.game_teams;
    for (let t of myTeams) {
      for (let i = gameTeams?.length - 1; i >= 0; i--) {
        if (t.kt_team_id === gameTeams[i].kt_team_id) {
          t.in_game = true;
          t.team_code = gameTeams[i].team_code
        }
      }
    }
    this.teamLoading = false;
    return myTeams;
  }

  updateTeamName(newName: string) {
    this.chosenTeam.team_name = newName;
  }

  normalizePlayerNum() {
    if (!this.numPlayers || this.numPlayers < this.invites.length + 1) {
      this.numPlayers = this.invites.length + 1
    }
    else this.numPlayers = Math.floor(this.numPlayers);
  }

  addInvite() {
    this.invites.push({})
  }

  setReady(val: number) {
    if (!this.isLoggedIn) {
      if (val) this.readyJoin = true;
      else this.readyJoin = false;
    }
  }

  removeInvite(i: number) {
    this.invites.splice(i, 1);
  }

  setInvite(invite: Invite, choice: string) {
    let iKeys = Object.keys(invite)
    for (let k of iKeys) {
      invite[k] = undefined
    }
    if (!choice) return;
    if (choice === 'email') {
      invite.inviteBy = 'email'
      invite.email = ""
    }
    else if (choice === 'phone') {
      invite.inviteBy = 'phone'
      invite.phone = ""
    }
    else {
      for (let m of this.memberList) {
        if (m.playerid === choice) {
          invite.inviteBy = 'playerid'
          invite.playerid = choice
        }
      }
    }
  }

  teamInGame(kt_team_id: string) {
    let found = this.targetGame.game_teams.filter((t) => t.kt_team_id === kt_team_id);
    if (found.length) return true;
    else return false;
  }

  setTeam(selected?: any) {
    selected = this.selected_team
    console.log(selected)
    if (!selected) return;
    if (selected === "new") this.chosenTeam = { team_name: "", kt_team_id: "new", members: [], team_image: "" };
    else {
      for (let t of this.teamList) {
        if (t.kt_team_id === selected) {
          this.chosenTeam = t;
          let me = this.auth.getPlayer();
          this.memberList = t.members.filter((v: Member) => v.playerid !== me.playerid);
        }
      }
    }
    this.editName = false;
    this.teamChosen.emit(true);
    if (this.teamInGame(this.chosenTeam.kt_team_id)) this.addTeam();
  }

  toggleEditName() {
    if (this.editName) {
      this.editName = false;
      //this.setTeam(this.chosenTeam.team_id)
    }
    else this.editName = true;
  }

  addTeam(): void {
    this.loading = true;
    this.err = "";
    this.normalizePlayerNum()
    this.gameService.addTeam(
      this.targetGame.gameid,
      this.chosenTeam.team_name.substring(0,125),
      this.chosenTeam.kt_team_id
    )
    .subscribe(
      joinResult => {
        window.location.reload();
      },
      err => {
        this.err = err.error.detail;
        this.loading = false;
      });
  }

}
